import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import URLs from '../../../../../utils/appURLs';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';
import axiosInstance from '../../../../../app/config/axiosInstance';

interface InitialState {
  isLoading: boolean;
  isLoadingStatus: boolean;
  data: any;
  dataByStatus: any;
  error: any;
}

const initialState: InitialState = {
  isLoading: false,
  isLoadingStatus: false,
  data: null,
  dataByStatus: [],
  error: null
};

type ThunkArgs = any;
type ReturnedType = any;
export interface Payload {
  starttime?: number | null;
  endtime?: number | null;
  payload?: string | null;
  filter?: string;
  signal?: any;
}

export const overViewAction = createAsyncThunk<ReturnedType, Payload>(
  'user/overview',
  async (params, thunkApi) => {
    const { payload, starttime, endtime, filter, signal } = params;
    try {
      let URL;
      if (filter === 'Vehicle Number') {
        URL = `${URLs.OVERVIEW}deviceid=${payload}&starttime=${starttime}&endtime=${endtime}`;
      } else if (filter === 'Vehicle Make') {
        URL = `${URLs.OVERVIEW}vehiclemodel=${payload}&starttime=${starttime}&endtime=${endtime}`;
      } else {
        URL = `${URLs.OVERVIEW}starttime=${starttime}&endtime=${endtime}`;
      }
      const data = await axiosInstance({
        method: 'GET',
        url: URL,
        signal: signal
      });
      return data?.data?.data;
    } catch (error: any) {
      if (error?.message !== 'canceled') {
        thunkApi.dispatch(
          updateToast({
            show: true,
            message: error?.response?.data?.message,
            severity: 'error'
          })
        );
      }
      return thunkApi.rejectWithValue(error);
    }
  }
);

const overViewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    clearOverview: state => {
      state.data = null;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(overViewAction.pending, state => {
        state.isLoading = true;
        state.data = current(state).data;
        state.error = null;
      })
      .addCase(overViewAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(overViewAction.rejected, (state, action) => {
        state.isLoading = false;
        state.data = current(state).data;
        state.error = null;
      });
  }
});

export const overViewData = overViewSlice.reducer;
export const { clearOverview } = overViewSlice.actions;
